import { useModalForm } from '@/shared/hooks/useModalForm';
import { useAlertContext } from '@/contexts/alert.context';
import { inspectionAssignmentService } from '@/services/inspectionAssignment.service';

export interface ProviderResponseFormData {
  notes?: string;
  rejectionNotes?: string;
}

interface UseProviderResponseModalProps {
  assignmentId: string;
  onClose: () => void;
  onSuccess: () => void;
  initialActionType: 'accept' | 'reject';
}

export function useProviderResponseModal({
  assignmentId,
  onClose,
  onSuccess,
  initialActionType,
}: UseProviderResponseModalProps) {
  const { notify } = useAlertContext();
  const actionType = initialActionType;

  const { form, isSubmitting, handleFormSubmit } = useModalForm<ProviderResponseFormData>({
    onSubmit: async (values) => {
      if (!assignmentId) {
        notify({ message: 'ID do direcionamento não encontrado', type: 'error' });
        throw new Error('ID do direcionamento não encontrado');
      }

      if (actionType === 'accept') {
        await inspectionAssignmentService.providerAccept(assignmentId, {
          notes: values.notes || 'Prestadora aceita a inspeção'
        });
      } else if (actionType === 'reject') {
        await inspectionAssignmentService.providerReject(assignmentId, {
          rejectionNotes: values.rejectionNotes || 'Prestadora recusa a inspeção'
        });
      }
    },
    onClose,
    onSuccess,
    successMessage: actionType === 'accept'
      ? 'Inspeção aceita com sucesso! Agora você pode direcioná-la para um inspetor.'
      : 'Inspeção recusada. O banco será notificado para redirecionar.',
    errorMessage: actionType === 'accept'
      ? 'Erro ao aceitar inspeção'
      : 'Erro ao recusar inspeção',
  });

  return {
    form,
    isSubmitting,
    handleFormSubmit,
  };
}
